import React from 'react';
import { Grid, List } from 'semantic-ui-react';

import { SPRAY_EVENT_WIZARD_EQUIPMENT_STEP } from 'services/sprayEventWizard/constants';
import WizardEventSummarySection from 'components/WizardEventSummarySection';
import { SprayEventOperation } from 'services/sprayEvents/types';
import SummaryEquipmentSetNameListItem from './components/SummaryEquipmentSetNameListItem';

interface Props {
    readOnly: boolean;
    sprayEventOperation: SprayEventOperation;
}

export default function SummaryEquipment({
    readOnly,
    sprayEventOperation
}: Props): React.ReactElement {
    return (
        <WizardEventSummarySection
            title="Equipment"
            sprayEventWizardStep={SPRAY_EVENT_WIZARD_EQUIPMENT_STEP}
            readOnly={readOnly}
        >
            <List>
                <Grid columns={1}>
                    <Grid.Row>
                        <Grid.Column>
                            <SummaryEquipmentSetNameListItem
                                equipmentSetId={
                                    sprayEventOperation?.sprayEquipmentSetId
                                }
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </List>
        </WizardEventSummarySection>
    );
}
